/**
 * 初期表示広告枠と遅延表示広告枠を扱うためだけのファーストクラスコレクション。
 */
export class AdSlotsRepository {
    private readonly initialLoadSlots: SlotDefinition[]
    private readonly lazyLoadSlots: SlotDefinition[]

    constructor(slots: SlotDefinition[]) {
        this.initialLoadSlots = slots.filter(slot => !slot.lazyLoad)
        this.lazyLoadSlots = slots.filter(slot => slot.lazyLoad)
    }

    public getInitialLoadSlots() {
        return this.initialLoadSlots
    }

    public getLazyLoadSlots() {
        return this.lazyLoadSlots
    }
}
